
























import {Component, Vue} from 'vue-property-decorator';
import AnimatedInput from "@/components/AnimatedInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import Browsercheck from "@/components/Browsercheck.vue";
import User from "@/models/User";
import AccountDataAES from "@/util/accountDataAES";
import AdminAdapter from "@/adapters/admin";
import Base64Encoder from "@/util/base64encoder";
import {Action, Mutation} from "vuex-class";

@Component({
  components: { AnimatedInput, LoadingButton, Browsercheck },
})
export default class RedeemInvitation extends Vue {

  password: string = "";
  repeat: string = "";
  loading: boolean = true;
  adminAdapter: AdminAdapter = new AdminAdapter();

  @Action login!: ({username, password, persistent}: {username: string, password: string, persistent: boolean}) => Promise<void>;

  get invitationToken(): string {
    return this.$router.currentRoute.params.token;
  }

  get name(): string {
    return this.$router.currentRoute.params.name.toLowerCase().trim();
  }

  async register() {

    if (this.password !== this.repeat) {
      this.$toast.error("Passwörter stimmen nicht überein.");
      return;
    }

    //Generate Keys and hashes:
    const tempAccountKey: CryptoKey | null = await AccountDataAES.generateMasterKeyFromUserPassword(this.name, this.password);
    if (!tempAccountKey) {
      throw new Error("Could not compute account key");
    }
    const tempMasterHash: string = await AccountDataAES.generateAuthenticationHashFromMasterKey(tempAccountKey, this.password);

    const accountKey: CryptoKey = await AccountDataAES.generateKey();
    const accountKeyIv: Uint8Array = AccountDataAES.generateIV();

    //EncryptAccountKeyWith password based master key:
    const aesInstance: AccountDataAES = new AccountDataAES(tempAccountKey);

    //Put everything into the user:
    const user: User = new User();
    user.email = this.name;
    user.password = tempMasterHash;
    user.accountKey = await aesInstance.wrapKey(accountKey, accountKeyIv);
    user.accountKeyIv = Base64Encoder.bytesToString(accountKeyIv);

    try {
      await this.adminAdapter.redeemInviation(user, this.invitationToken);

      await this.login({username: this.name, password: this.password, persistent: true});

      this.$toast.success("Account erstellt.");
      this.$router.push("/account");
    } catch (error) {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    }

  }

  created() {
    this.adminAdapter.checkInviation(this.name, this.invitationToken).then(() => {
      this.loading = false;
    }).catch(() => {
      if (this.$store.state.account.accountData) {
        this.$router.push("/account");
      } else {
        this.$router.push("/?loginandgoto=/account"); // TODO show reason?
      }
    });
  }
}
